/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-07-26",
    versionChannel: "nightly",
    buildDate: "2023-07-26T00:20:00.702Z",
    commitHash: "3326aef6a8b7c2b496c4538d1674e5b14944baa7",
};
